import { Link } from 'react-router-dom';
import { FileText } from 'lucide-react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { Button } from '../ui/button';
import CarnetNotesFormateur from '../CarnetNotesFormateur';

// Détail de toutes les notes d'un stagiaire, par support puis par catégorie
export const DetailNotesDialog = ({ stagiaire, onClose }) => (
  <Dialog open={!!stagiaire} onOpenChange={(o) => !o && onClose()}>
    <DialogContent className="max-w-4xl max-h-[88vh] overflow-y-auto" data-testid="carnet-detail-dialog">
      <DialogHeader>
        <DialogTitle className="font-display text-xl">
          {stagiaire?.prenom} {stagiaire?.nomFamille}
        </DialogTitle>
      </DialogHeader>
      {stagiaire && (
        <>
          <CarnetNotesFormateur notes={stagiaire.liste} title="Toutes les notes" />
          <div className="flex justify-end">
            <Link to={`/bulletin-notes?id=${stagiaire.stagiaire_id}`}>
              <Button variant="outline" size="sm" data-testid="carnet-detail-bulletin">
                <FileText className="h-4 w-4 mr-2" />
                Ouvrir le bulletin
              </Button>
            </Link>
          </div>
        </>
      )}
    </DialogContent>
  </Dialog>
);
